export type { ExportHistoryTranslations } from "./export-history-pt-br";
export { EXPORT_HISTORY_PT_BR } from "./export-history-pt-br";
export { EXPORT_HISTORY_EN_US } from "./export-history-en-us";
export { EXPORT_HISTORY_ES_ES } from "./export-history-es-es";
export { EXPORT_HISTORY_ES_MX } from "./export-history-es-mx";
export { EXPORT_HISTORY_FR_FR } from "./export-history-fr-fr";
